import { useMutation } from '@src/query';

import { partsKeyPrefix } from './usePartFormMutations';


/** Parse a CSV → headers + suggested mapping (#278). Variables: `{ sellerId, file }`. */
function useCsvImportParseMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, sellerId, file }) => {
      const body = new FormData();
      body.append('file', file);
      return apiClient.request({
        url: `/inventory/parts/${sellerId}/import/parse/`,
        method: 'POST',
        payload: body,
        contentType: 'multipart/form-data',
      });
    },
    ...params,
  });
}


/**
 * Commit (or dry-run) a CSV import (#278). Variables:
 * `{ sellerId, file, mapping, dryRun }`. On a real run (dryRun=false) invalidates the
 * parts list so new drafts appear.
 */
function useCsvImportCommitMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, file, mapping, dryRun }) => {
      const body = new FormData();
      body.append('file', file);
      body.append('mapping', JSON.stringify(mapping));
      body.append('dry_run', dryRun ? 'true' : 'false');
      return apiClient
        .request({
          url: `/inventory/parts/${sellerId}/import/commit/`,
          method: 'POST',
          payload: body,
          contentType: 'multipart/form-data',
        })
        .then((data) => {
          if (!dryRun) {
            queryClient.invalidateQueries({ queryKey: partsKeyPrefix(sellerId) });
          }
          return data;
        });
    },
    ...params,
  });
}


export { useCsvImportCommitMutation, useCsvImportParseMutation };
